import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LanguageUtils } from '../../utils/language.utils';
import { IProvincesService, ProvinceResponse } from './provinces.interface';

@Injectable({
  providedIn: 'root'
})
export class ProvincesService implements IProvincesService {
  cache = new Map<string, ProvinceResponse>();

  constructor(private httpClient: HttpClient) { }

  getProvinces(): Observable<ProvinceResponse> {
    const cached = this.cache.get(LanguageUtils.getLanguage());
    if (cached) {
      return of(cached);
    } else {
      return this.httpClient.get<ProvinceResponse>(environment.apiPublicUrl + '/provinces?language=' + LanguageUtils.getLanguage()).pipe(
        tap(data => this.cache.set(LanguageUtils.getLanguage(), data))
      );
    }
  }
}
